
/**
 * @nullable
 */
export type ComposerPayloadTweetType = typeof ComposerPayloadTweetType[keyof typeof ComposerPayloadTweetType] | null;


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ComposerPayloadTweetType = {
  ORIGINAL: 'ORIGINAL',
  REPLY: 'REPLY',
  QUOTE: 'QUOTE',
} as const;
